import CoreLayout from './containers/CoreLayout';

export default CoreLayout;
